import React from "react";
import "../Content.scss";

const ContentWrapper: React.FC = (props) => {
    return (
        <div className="content__wrapper">
            {props.children}
        </div>
    );
};

export default ContentWrapper;
